import { ElementProps, FloatingContext } from "@floating-ui/react";
import { useId, useMemo } from "react";

const usePopoverAria = (context: FloatingContext): ElementProps => {
  const id = useId();
  return useMemo(
    () => ({
      reference: {
        "aria-expanded": context.open,
        "aria-controls": id,
      },
      floating: {
        id,
      },
    }),
    [context.open, id]
  );
};

export default usePopoverAria;
